/**
 * 创建人：但志强
 * 时间：2019-6-11
 * 描述：将字典数据的id value 值转换成中文Name
 * 更新记录: 
 */
import { Pipe, PipeTransform } from '@angular/core';
import { SwJwtService } from '../../serves/sw-jwt.service';


/**
 * 将字典值转换成中文 第一种可以传入转换的值
 * @example  <span> {{ 'CKF010102' | Dictionary:'dictionaryValue' }}</span>
 * @example <span> {{ 'CKF010102' | Dictionary }}</span>
 */
@Pipe({
  name: 'dictionary'
})
export class DictionaryPipe implements PipeTransform {

  constructor(private jwt :SwJwtService){}


  /**
   * 
   * @param value 传递的值 
   * @param dictionaryId  转换的值 默认是dictionaryValue 可以自定义输入 
   */
  transform(value: any,dictionaryId?:any): any {
    if(value){
      let dictionary = JSON.parse(this.jwt.getToken("dictionary"));
       //获取当前语言
      let currLanguage = this.jwt.getToken('language')
      if(dictionaryId){
         let dic = dictionary.filter(x=>x[dictionaryId] == value); 
         let text = ''
         if(dic.length>0){
          if(currLanguage == 'en-US' && dic[0]['dictionaryNameEn']){
            text = dic[0]['dictionaryNameEn']
           }else {
            text = dic[0]["dictionaryName"]
           }
         }
        return dic.length>0? text:"";
      }else{
          let dic = dictionary.filter(x=>x.dictionaryValue == value); 
          let text = ''
          if(dic.length > 0){
            if(currLanguage == 'en-US' && dic[0]['dictionaryNameEn']){
              text = dic[0]['dictionaryNameEn']
            }else {
              text = dic[0]["dictionaryName"]
            }
          }
          return dic.length>0? text:"";
      }
    }else{
      return "";
    }
  }
}

//前台写法
//<span> {{ 'CKF010102' | dictionary:'dictionaryValue' }}</span>
//<span> {{ 'CKF010102' | dictionary }}</span>